module.exports = __webpack_public_path__ + "static/media/korn.8bd807f5.m4a";